interface PhoneNumber {
  number: string;
}

interface CustomerDetails {
  countryCode: number;
}

interface EmployeeDetails {
  companyId: string;
  employeeStatus: number;
  employeeType: number;
}

interface User {
  id: string;
  isDeleted: boolean;
  username: string;
  firstName: string;
  lastName: string;
  created: string; // ISO date string
  lastLogin: string; // ISO date string
  updatedAt: string; // ISO date string
  userType: number;
  phoneNumber: PhoneNumber;
  customerDetails: CustomerDetails;
  employeeDetails: EmployeeDetails;
}

export interface Order {
  orderId: string;
  customerId: string;
  type: number;
  status: number;
  createdAt: string;
  user: User;
}

export enum OrderTypeEnum {
	OneTime = 1,
	Installment = 2,
	PayAsYouGo = 3
}

// Helper function to convert enum value to display text
export const getOrderTypeText = (orderType: number): string => {
	switch (orderType) {
		case OrderTypeEnum.OneTime:
			return "One Time";
		case OrderTypeEnum.Installment:
			return "Installment";
		case OrderTypeEnum.PayAsYouGo:
			return "Pay As You Go";
		default:
			return "Unknown";
	}
};

// Helper function to convert string to enum value
const getOrderTypeValue = (orderTypeText: string): number | undefined => {
	switch (orderTypeText) {
		case "OneTime":
			return OrderTypeEnum.OneTime;
		case "Installment":
			return OrderTypeEnum.Installment;
		case "PayAsYouGo":
			return OrderTypeEnum.PayAsYouGo;
		default:
			return undefined;
	}
};